<template>
	<page-container :page="page" :locale="locale">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="highlight-section">
			<highlights-map :items="highlights" />
			<div class="fine-bg-pattern" />
		</section>

		<contentblocks :items="page.contentblocks" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();
useRemoveGifty();

const { data: highlights } = await useWebsiteFetch('highlights', {
	query: { language: locale.value },
	key: `${locale.value}/highlights`,
});
</script>

<style lang="scss" scoped>
.highlight-section {
	background: var(--primary-background-color);
	position: relative;
}

.fine-bg-pattern {
	position: absolute;
	inset: 0;
	width: 100%;
	z-index: 1;
	opacity: 0.9;
}
</style>
